// extracted by mini-css-extract-plugin
module.exports = {"nav":"_s8NZEPh3"};